import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import TitleDiv from 'views/components/UI/TitleDiv'
import Select from 'views/components/UI/Select'
import { StrokedButton } from 'views/components/UI/Buttons'
import { generalDataSelector } from 'ducks/auth'
import getAllSkills from 'services/common/skills/getAll'
import getSkillByFilter from 'services/common/skills/getByFilters'
import { ActionEditSkill } from 'views/components/UI/BluesiteTable/Actions/GridActions'
import { useNotification } from 'lib/context/notification.context'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import IconMagnifying from 'assets/icons/iconMagnifying.png'
import { headers } from './constans'
import { MagnifyingGlass, SearchButton } from './styled'

type Tskill = {
  skillsData: object[]
  totalPages: number
}

const Questions: FC = () => {
  const { getError, getWarning } = useNotification()

  const { data: generalData } = useSelector(generalDataSelector)
  const [skillOptions, setSkillOptions] = useState<any[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  const [filterByLevel, setFilterByLevel] = useState<string>('')
  const [filterByGroup, setFilterByGroup] = useState<string>('')
  const [filterBySkill, setFilterBySkill] = useState<string>('')

  const [skillsPagesData, setSkillsPagesData] = useState<Tskill>({
    skillsData: [],
    totalPages: 0,
  })
  const [optionsLevelGroup, setFilterLevelGroup] = useState({
    levelOptions: [],
    groupOptions: [],
  })

  useEffect(() => {
    const getskillsBank = async (page = 1, limit = 10, categoryId = 2) => {
      await getAllSkills(limit, page, categoryId).then(({ skills, total_pages }) => {
        setSkillsPagesData({
          skillsData: skills,
          totalPages: total_pages,
        })
      })
    }
    getskillsBank()

    const levelOptionsData = generalData.level
      .map((level: any) => {
        if (level.id === 1 || level.name === 'Betesa' || level.name === 'Estratégico-Táctico' || level.name === 'Táctico-Operativo') {
          return null
        }
        return {
          value: level.id,
          label: level.name,
        }
      })
      .filter((option: any) => option !== null)

    const groupOptionsData = generalData.group
      .map((group: any) => {
        if (group.id === 1 || group.name === 'Betesa') {
          return null
        }
        return {
          value: group.id,
          label: group.name,
        }
      })
      .filter((option: any) => option !== null)

    setFilterLevelGroup({
      levelOptions: levelOptionsData,
      groupOptions: groupOptionsData,
    })
  }, [generalData.group, generalData.level])

  function checkFilter(obj: any) {
    const keys = Object.keys(obj)
    for (let i = 0; i < keys.length; i++) {
      const value = obj[keys[i]]

      if (typeof value === 'number' && value > 0) {
        return true
      }

      if (typeof value === 'string' && value.trim() !== '') {
        return true
      }
    }

    return false
  }

  function handleGetAllSkillsByFilter(page: number) {
    const groupId = filterByGroup
    const levelId = filterByLevel
    const skillId = filterBySkill
    const emptyRequest = checkFilter({ groupId, levelId })
    const categoryId = 2
    if (!emptyRequest && !page) {
      getError('Debes seleccionar mínimo un valor para realizar la consulta')
    }
    if (optionsLevelGroup.groupOptions.length > 0) {
      getSkillByFilter({ categoryId, groupId, levelId, skillId }, page, 10)
        .then(({ status, skills, total_pages }) => {
          if (status === 'OK') {
            setSkillsPagesData({
              skillsData: skills,
              totalPages: total_pages,
            })
          } else {
            getWarning('No se encontraron datos')
            setSkillsPagesData({
              skillsData: [],
              totalPages: 0,
            })
          }
        })
        .catch(() => {
          getWarning('No se encontraron coincidencias con tu busqueda. intenta con otros términos')
        })
    }
  }

  useEffect(() => {
    handleGetAllSkillsByFilter(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterByGroup, filterByLevel, filterBySkill])

  const handleGetSkillByFilter = (groupId?: number | undefined, levelId?: number | undefined) => {
    if (groupId !== 0 && levelId !== 0) {
      getSkillByFilter({ groupId: groupId, levelId: levelId }, 1, 100).then((response) => {
        if (response.status === 'OK') {
          const skillsFormated = response.skills.map((skill: any) => {
            return {
              value: skill.id,
              label: skill.skill,
            }
          })
          setSkillOptions(skillsFormated)
        } else {
          getWarning('No se encontraron datos. Intenta con otros términos')
        }
      })
    }
  }

  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    handleGetAllSkillsByFilter(pageNumber)
  }

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Banco de competencias</h2>
        <Link to="/modules/skills/new">
          <StrokedButton>Nueva competencia</StrokedButton>
        </Link>
      </TitleDiv>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginBottom: 35,
          marginTop: 40,
          alignItems: 'center',
          gap: 35,
        }}
      >
        <span>Buscar por:</span>
        <Select
          label="Grupo"
          options={optionsLevelGroup.groupOptions.length > 0 ? optionsLevelGroup.groupOptions : []}
          value={filterByGroup}
          onChange={(e) => {
            setFilterByGroup(e === '0' ? '' : e)
            handleGetSkillByFilter(parseInt(e), parseInt(filterByLevel))
            setFilterBySkill('')
          }}
        />

        <Select
          label="Nivel"
          options={optionsLevelGroup.levelOptions.length > 0 ? optionsLevelGroup.levelOptions : []}
          value={filterByLevel}
          onChange={(e) => {
            setFilterByLevel(e === '0' ? '' : e)
            handleGetSkillByFilter(parseInt(filterByGroup), parseInt(e))
            setFilterBySkill('')
          }}
        />
        <Select
          disabled={filterByGroup === '' || filterByLevel === ''}
          label="Competencia"
          options={skillOptions.length > 0 ? skillOptions : []}
          value={filterBySkill}
          onChange={(e) => {
            setFilterBySkill(e === '0' ? '' : e)
          }}
        />
        <div>
          <HighlightOffIcon
            style={{ cursor: 'pointer', color: 'gray', marginLeft: '-10px', marginRight: '-10px' }}
            onClick={() => {
              setFilterByGroup('')
              setFilterByLevel('')
              setFilterBySkill('')
              handleGetAllSkillsByFilter(1)
            }}
          />
        </div>

        <SearchButton onClick={() => handleGetAllSkillsByFilter(1)} style={{ fontSize: 14 }}>
          <MagnifyingGlass src={IconMagnifying} />
        </SearchButton>
      </div>
      <BluesiteTableComponent
        ActionComponent={ActionEditSkill}
        data={skillsPagesData.skillsData}
        totalPages={skillsPagesData.totalPages}
        headers={headers}
        searchBar={false}
        handlePagination={handlePagination}
        currentPage={currentPage}
        searchLabel=""
      />
    </MainLayout>
  )
}
export default Questions
